module.exports = "../dist/img/upper-banner-24.1970.jpg";